<template>
  <div class="text-left">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title pb-3"> HAPPENSTANCE </v-list-item-title>
        <v-list-item-subtitle class="pb-2">
          {{ username }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav active-class="text--accent-4">
      <v-list-item
        :to="item.path == '#' ? '' : item.path"
        v-for="item in items"
        :key="item.title"
        :value="item.title"
        link
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        { title: "Dashboard", icon: "mdi-view-dashboard", path: "/dashboard" },
        { title: "My Profile", icon: "mdi-account-settings", path: "/profile" },
        { title: "Directory", icon: "mdi-account-group", path: "/directory" },
        { title: "Products", icon: "mdi-view-list", path: "/products" },
        { title: "Shops", icon: "mdi-store-outline", path: "/shops" },
        { title: "Sales", icon: "mdi-shopping", path: "/sales" },
        {
          title: "Stock",
          icon: "mdi-briefcase-check-outline",
          path: "/stocks",
        },
        { title: "Logout", icon: "mdi-logout", path: "/logout" },
      ],
      right: null,
      page: null,
      username: "",
    };
  },
  created() {
    this.$auth.getUser().then(
      (response) => {
        this.username = response.name;
      },
      (error) => {
        console.log(error);
        this.username = "";
      }
    );
  },
  methods: {},
};
</script>
